import React, { useContext } from 'react';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { FaSitemap, FaClipboardList, FaPlusSquare, FaRulerCombined, FaMoneyBillWave, FaUsers, FaCog } from 'react-icons/fa';

import ManageCarModels from './admin/ManageCarModels';
import ManageServiceMenus from './admin/ManageCourses';
import ManageOptions from './admin/ManageOptions';
import ManageVehicleSizes from './admin/ManageVehicleSizes';
import ManagePrices from './admin/ManagePrices';
import ManageUsersPage from './admin/ManageUsersPage';
import ShopSettingsPage from './admin/ShopSettingsPage';
import PermissionRoute from '../components/PermissionRoute';
import AuthContext from '../context/AuthContext';
import { hasPermission } from '../utils/permissions';

const SettingsPage = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();

    const tabs = [
        { to: '/settings/shop', icon: <FaCog />, label: '매장 설정', permission: 'settings:shop', isIndex: true },
        { to: '/settings/servicemenus', icon: <FaClipboardList />, label: '서비스 메뉴', permission: 'settings:menus' },
        { to: '/settings/options', icon: <FaPlusSquare />, label: '옵션', permission: 'settings:options' },
        { to: '/settings/prices', icon: <FaMoneyBillWave />, label: '가격표', permission: 'settings:prices' },
        { to: '/settings/vehiclesizes', icon: <FaRulerCombined />, label: '차량 사이즈', permission: 'settings:sizes' },
        { to: '/settings/carmodels', icon: <FaSitemap />, label: '차종', permission: 'settings:menus' },
        { to: '/settings/users', icon: <FaUsers />, label: '직원 계정', permission: 'users:manage' },
    ];

    return (
        <div className="settings-page">
            <div className="settings-tabs">
                {tabs
                    .filter(t => hasPermission(user?.role, t.permission))
                    .map(t => (
                        <NavLink key={t.to} to={t.to}
                            className={`settings-tab ${location.pathname === t.to || (t.isIndex && location.pathname === '/settings') ? 'active' : ''}`}>
                            <span className="settings-tab-icon">{t.icon}</span>
                            {t.label}
                        </NavLink>
                    ))
                }
            </div>
            <div className="settings-content">
                <Routes>
                    <Route path="shop" element={<PermissionRoute permission="settings:shop"><ShopSettingsPage /></PermissionRoute>} />
                    <Route path="servicemenus" element={<PermissionRoute permission="settings:menus"><ManageServiceMenus /></PermissionRoute>} />
                    <Route path="options" element={<PermissionRoute permission="settings:options"><ManageOptions /></PermissionRoute>} />
                    <Route path="prices" element={<PermissionRoute permission="settings:prices"><ManagePrices /></PermissionRoute>} />
                    <Route path="vehiclesizes" element={<PermissionRoute permission="settings:sizes"><ManageVehicleSizes /></PermissionRoute>} />
                    <Route path="carmodels" element={<PermissionRoute permission="settings:carmodels"><ManageCarModels /></PermissionRoute>} />
                    <Route path="users" element={<PermissionRoute permission="users:manage"><ManageUsersPage /></PermissionRoute>} />
                    <Route index element={<PermissionRoute permission="settings:shop"><ShopSettingsPage /></PermissionRoute>} />
                </Routes>
            </div>
        </div>
    );
};

export default SettingsPage;
